//================================================================
//  Component: Approver Card
//================================================================

//  Purpose: This is a mobile responsive version of the approver table row

//  Properties:
//    - approver = {A string, a short message}
//    - currentView = {useState, determines what option has been selected in the dropdown}

//  Example:
//    <ApproverCard
//      approver={approver}
//      currentView={currentView}
//    ></ApproverCard>    

//================================================================


//Libraries
import React from 'react';

//Contexts

//Components
import ManageApproverReassign from '../../../Components/ManageApproverReassign/ManageApproverReassign';

//Functions
import ConvertDate from '../../../Library/ConvertDate';

//Images

//CSS


export default function ApproverCard({
  approver,
  currentView
}) {

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (
    <div className='bg-white mb-4 rounded-lg shadow py-[12px]'>
      {
        currentView === 'History' ?

        // History View
        <>
            {/* Role  */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>{approver?.role}</h6>
                </div>
            </div>

            {/* New Approver */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>New Approver</h6>
                    <p className='font-medium mb-0 capitalize text-[15px]'>{approver?.newapprover?.givenname} {approver?.newapprover?.surname}</p>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.newapprover?.email}</p>
                </div>
            </div>

            {/* Previous Approver */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>Previous Approver</h6>
                    <p className='font-medium mb-0 capitalize text-[15px]'>{approver?.previousapprover?.givenname} {approver?.previousapprover?.surname}</p>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.previousapprover?.email}</p>
                </div>
            </div>

            {/* Justification */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>Justification</h6>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.justification}</p>
                </div>
            </div>

            {/* Modified By */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>Modified By</h6>
                    <p className='font-medium mb-0 capitalize text-[15px]'>{approver?.actionedby?.givenname} {approver?.actionedby?.surname}</p>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.actionedby?.email}</p>
                </div>
            </div>

            {/* Modified Date */}
            <div className='px-4 py-[12px] flex justify-between items-center'>
                <h6 className='font-medium mb-0'>Modified Date</h6>
                <p className='mb-0 text-medium'>
                    {ConvertDate(approver?.actioneddate)}
                </p>
            </div>
        </>
        :

        // Approvers View
        <>
            {/* Role */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-2'>{approver?.role}</h6>
                    <p className='font-medium mb-0 capitalize text-[15px]'>{approver?.approvergivenname} {approver?.approversurname}</p>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.approveremail}</p>
                </div>
            </div>

            {/* Last Modified By Section */}
            <div className='px-4 py-[12px] border-b border-[#C8C8C9]'>
                <div className='mb-2'>
                    <h6 className='font-medium mb-1'>Last Modified By</h6>
                    <p className='font-medium mb-0 capitalize text-[15px]'>
                        {approver?.lastmodifiedby?.givenname} {approver?.lastmodifiedby?.surname}
                    </p>
                    <p className='text-[#504f4f] text-sm mb-0'>{approver?.lastmodifiedby?.email}</p>
                </div>
            </div>

            {/* Last Modified Date */}
            <div className='px-4 pt-[12px] pb-2 flex justify-between items-center'>
                <h6 className='font-medium mb-0'>Last Modified</h6>
                <p className='mb-0 text-medium'>{ConvertDate(approver?.lastmodifieddate)}</p>
            </div>

            {/* Reassign Button */}
            <ManageApproverReassign
                approver={approver}
            ></ManageApproverReassign>

        </>
      }
    </div>
  )
}
